import { Link, useParams } from "react-router-dom";
import { UrlPath } from "utility/routes";
import BreadcrumbCompany from "../BreadcrumbCompany";
import ProductList from "components/ProductList/ProductList";
import LogoDiscountPromo from "./DiscountPromo/LogoDiscountPromo";
import LogoPromo from "./Promo/LogoPromo";
import BulletpointsPromo from "./Promo/BulletpointsPromo";
import InfoTextPromo from "./Promo/InfoTextPromo";
import ExtraLinksPromo from "./Promo/ExtraLinksPromo";
import SearchWordsPromo from "./Promo/SearchWordsPromo";


const WebshopProductList: React.FC = () => {
    return <>
        <BreadcrumbCompany />
        <LogoDiscountPromo/>
        <ProductList displayExtra={true} />
    </>
}

export default WebshopProductList;